module.exports = __webpack_public_path__ + "img/unfold_logo_anim1.5cfd198f.svg";